<ng-container
  *ngrxLet="{
    singlePackagingResource: singlePackagingResource$,
    validationResource: validationResource$
  } as vm"
>
  <hazmatsuite-next-dangerousgood-selection
    *ngIf="!dangerousGood; else details"
    [showCancelButton]="true"
    [transportMode]="transportMode"
    [excludedDgClasses]="[7]"
    (selectDangerousGood)="
      selectDangerousGood(
        $event,
        vm?.singlePackagingResource['CannotLoadTogetherWith']
      )
    "
  ></hazmatsuite-next-dangerousgood-selection>

  <ng-template #details>
    <div>
      <div id="ch-ggs-web-suite-packing-details">
        <h4 class="d-flex align-items-baseline">
          {{ vm?.singlePackagingResource['TitleContent'] }}
        </h4>
        <hr />
        <form [formGroup]="formGroup">
          <div class="form-group row">
            <label for="properShippingName" class="col-sm-3 col-form-label">{{
              vm?.singlePackagingResource['DangerousGood']
            }}</label>
            <div class="col-sm-9">
              <input
                id="properShippingName"
                type="text"
                class="form-control"
                formControlName="properShippingName"
                readonly
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3">{{
              vm?.singlePackagingResource['EnvironmentallyHazardous']
            }}</label>
            <div class="col-sm-9">
              <div class="form-check">
                <input
                  id="isEnvironmentallyHazardous"
                  type="checkbox"
                  class="form-check-input"
                  [checked]="
                    innerPackagingModel?.IsEnvironmentallyHazardous ||
                    innerPackagingModel?.IsEnvironmentallyHazardousFromDb
                  "
                  (change)="changeIsEnvironmentallyHazardous($event)"
                  formControlName="isEnvironmentallyHazardous"
                />
                <label
                  class="form-check-label"
                  for="isEnvironmentallyHazardous"
                  >{{
                    vm?.singlePackagingResource['EnvironmentallyHazardousItem']
                  }}</label
                >
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            *ngIf="innerPackagingModel?.IsFlashpointRequired"
          >
            <label
              for="frm-ch-ggs-web-suite-reference"
              class="col-sm-3 col-form-label h4"
            >
              {{ vm?.singlePackagingResource['FlashPoint'] }}
            </label>
            <div class="col-sm-2">
              <input
                type="text"
                class="form-control"
                id="lowerFlashpoint"
                formControlName="lowerFlashpoint"
              />
            </div>
            <div class="col-sm-1">
              <label class="col-form-label">°C</label>
            </div>
            <span
              *ngIf="
                lowerFlashpoint?.invalid &&
                (lowerFlashpoint?.dirty || lowerFlashpoint?.touched)
              "
              class="text-danger"
            >
              {{ vm?.validationResource['InputRequired'] }}
            </span>
          </div>

          <h4>{{ vm?.singlePackagingResource['TitleClosure'] }}</h4>
          <hr />

          <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="countOfPackagings">{{
              vm?.singlePackagingResource['ClosureCountAndType']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-3">
                  <div>
                    <input
                      class="form-control"
                      type="number"
                      step="1"
                      id="countOfPackagings"
                      formControlName="countOfPackagings"
                    />
                  </div>
                  <span
                    *ngIf="
                      countOfPackagings?.invalid &&
                      (countOfPackagings?.dirty || countOfPackagings?.touched)
                    "
                    class="text-danger"
                  >
                    {{ vm?.validationResource['PositiveInteger'] }}
                  </span>
                </div>
                <div class="col-sm-9">
                  <div>
                    <input
                      class="form-control"
                      type="text"
                      id="alternativePackagingType"
                      formControlName="alternativePackagingType"
                    />
                  </div>
                  <span
                    *ngIf="
                      alternativePackagingType?.invalid &&
                      (alternativePackagingType?.dirty ||
                        alternativePackagingType?.touched)
                    "
                    class="text-danger"
                  >
                    {{ vm?.validationResource['InputRequired'] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3">{{
              vm?.singlePackagingResource['AmountType']
            }}</label>
            <div class="col-sm-9">
              <div class="form-check radio">
                <input
                  id="singlePackaging"
                  type="radio"
                  formControlName="isTotalQuantity"
                  [value]="false"
                />
                <label for="singlePackaging">{{
                  vm?.singlePackagingResource['IsSingleQuantity']
                }}</label>
              </div>
              <div class="form-check radio">
                <input
                  id="totalPackaging"
                  type="radio"
                  formControlName="isTotalQuantity"
                  [value]="true"
                />
                <label for="totalPackaging">{{
                  vm?.singlePackagingResource['IsTotalQuantity']
                }}</label>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            *ngIf="innerPackagingModel?.IsLithiumBattery"
          >
            <label class="col-sm-3">
              {{ vm?.singlePackagingResource['LithiumBatteriesSectionIB'] }}
            </label>
            <div class="col-sm-9">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="lithiumBatteryShipmentModeIB"
                  formControlName="lithiumBatteryShipmentModeIB"
                  [checked]="innerPackagingModel?.LithiumBatteryShipmentModeIB"
                />
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="netWeight">{{
              vm?.singlePackagingResource['NetAmount']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-3">
                  <div>
                    <input
                      [class.form-control-mandatory]="
                        innerPackagingModel?.IsNetWeightMandatory
                      "
                      class="form-control"
                      type="text"
                      id="netWeight"
                      formControlName="netWeight"
                    />
                  </div>
                  <span
                    *ngIf="
                      netWeight?.invalid &&
                      (netWeight?.dirty || netWeight?.touched)
                    "
                    class="text-danger"
                  >
                    {{ vm?.validationResource['PositiveInteger'] }}
                  </span>
                </div>
                <div class="col-sm-3">
                  <label class="col-form-label">
                    {{ innerPackagingModel?.NetWeightUnitSymbol }}
                  </label>
                </div>
                <ng-container *ngIf="innerPackagingModel?.IsNetVolumeEnabled">
                  <div class="col-sm-3">
                    <div>
                      <input
                        [class.form-control-mandatory]="
                          innerPackagingModel?.IsNetVolumeMandatory
                        "
                        class="form-control"
                        type="text"
                        id="netVolume"
                        formControlName="netVolume"
                      />
                    </div>
                    <span
                      *ngIf="
                        netVolume?.invalid &&
                        (netVolume?.dirty || netVolume?.touched)
                      "
                      class="text-danger"
                    >
                      {{ vm?.validationResource['PositiveInteger'] }}
                    </span>
                  </div>
                  <div class="col-sm-3">
                    <label class="col-form-label">
                      {{ innerPackagingModel?.NetVolumeUnitSymbol }}
                    </label>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label
              class="col-sm-3 col-form-label"
              [class.h4]="innerPackagingModel?.IsGrossWeightMandatory"
            >
              {{ vm?.singlePackagingResource['GrossWeight'] }}
            </label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-3">
                  <div>
                    <input
                      [class.form-control-mandatory]="
                        innerPackagingModel?.IsGrossWeightMandatory
                      "
                      class="form-control"
                      type="text"
                      id="grossWeight"
                      formControlName="grossWeight"
                    />
                  </div>
                  <span
                    *ngIf="
                      grossWeight?.invalid &&
                      (grossWeight?.dirty || grossWeight?.touched)
                    "
                    class="text-danger"
                  >
                    {{ vm?.validationResource['PositiveInteger'] }}
                  </span>
                </div>
                <div class="col-sm-3">
                  <label class="col-form-label">{{
                    innerPackagingModel?.GrossWeightUnitSymbol
                  }}</label>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            *ngIf="innerPackagingModel?.IsNetExplosiveMassMandatory"
          >
            <label class="col-sm-3 col-form-label">{{
              vm?.singlePackagingResource['NetExplosiveMass']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-3">
                  <div>
                    <input
                      class="form-control"
                      type="text"
                      id="netExplosiveMass"
                      formControlName="netExplosiveMass"
                    />
                  </div>
                  <span
                    *ngIf="
                      netExplosiveMass?.invalid &&
                      (netExplosiveMass?.dirty || netExplosiveMass?.touched)
                    "
                    class="text-danger"
                  >
                    {{ vm?.validationResource['PositiveInteger'] }}
                  </span>
                </div>
                <div class="col-sm-3">
                  <label class="col-form-label">{{
                    innerPackagingModel?.NetExplosiveMassUnitSymbol
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</ng-container>
